import { useState } from "react";
import { motion } from "framer-motion";
import { toast } from "sonner";
import { PRODUCTS, DISCORD_URL } from "../../lib/site";
import { useI18n } from "../../i18n/LanguageContext";
import { Reveal, Eyebrow, staggerParent } from "./Reveal";
import { ProductCard } from "./ProductCard";
import { ProductDialog } from "./ProductDialog";

export const Products = () => {
  const { t, product } = useI18n();
  const [active, setActive] = useState(null);
  const [open, setOpen] = useState(false);

  const openProduct = (p) => { setActive(p); setOpen(true); };
  const buy = (p) => {
    const info = product(p.id);
    toast.success(`${t.products.buyToast} “${info.title}”`, {
      description: t.products.buyToastDesc,
    });
    window.open(DISCORD_URL, "_blank", "noopener");
  };

  return (
    <section id="products" className="relative py-24 md:py-32" data-testid="products-section">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-14">
          <div>
            <Reveal><Eyebrow>{t.products.eyebrow}</Eyebrow></Reveal>
            <Reveal delay={0.05}>
              <h2 className="mt-4 font-display font-bold text-4xl md:text-5xl tracking-tight">
                {t.products.title}
              </h2>
            </Reveal>
          </div>
          <Reveal delay={0.1}>
            <p className="max-w-sm text-slate-400 text-base leading-relaxed lg:text-right">
              {t.products.subtitle}
            </p>
          </Reveal>
        </div>

        <motion.div
          variants={staggerParent}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: "-60px" }}
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6"
        >
          {PRODUCTS.map((p) => (
            <ProductCard key={p.id} product={p} info={product(p.id)} labels={t.products} onOpen={openProduct} onBuy={buy} />
          ))}
        </motion.div>
      </div>

      <ProductDialog
        product={active}
        info={active ? product(active.id) : null}
        labels={t.products}
        open={open}
        onOpenChange={setOpen}
        onBuy={buy}
      />
    </section>
  );
};
